module.exports = {"normal":"Normal","abnormal":"Abnormal","closedHole":"Closed Holes","normalOperationRate":"Normal Operation Rate","spareParts":"Spares","pinStandard":"Pin Spec","pinChangeMethod":"Pin Replacement Method","batteryLevel":"Battery Level","batteryWarning":"Battery Warning","pinFlipped":"Pin Flipped","storage":"Storage","noData":"No data available."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cd002.json
// module id = CYou
// module chunks = 2